<template>
  <div class="detail-view"> 
      <div class="view-top">
          <div class="detail-title" v-if="bookName">{{bookName.bookName}} {{bookName.chaptername}}({{pieceIndex+1}}/{{bookName.imagesEntities.length}})</div>
          <div v-else></div>
          <div class="detail-btn">
              <div class="detail-btn-item" v-for="(items,indexs) in btnList" :key="indexs">
                <ul :class="[indexs===0?'margin-right':'']">
                    <li v-for="(item,index) in items" :key="index" @click="operationImg(item)">
                        <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom"> 
                            <div class="item" >
                                <img :src="item.up" :alt="item.name" class="img1">
                                <img :src="item.down" :alt="item.name" class="img2">
                            </div>
                        </el-tooltip>
                    </li>
                </ul>
              </div>
          </div>
          <div class="clone-view">
              <img src="@/assets/detail/newspapers_button_off_up.png" class="img1" @click="goRouter">
              <img src="@/assets/detail/newspapers_button_off_down.png" class="img2" @click="goRouter">
          </div>
      </div>
      <div class="view-bottom main">
        <div class="main-left" :style="{width:!navLeftIsShow?'0':'240px'}">
            <div class="nav-view">
                <vue-scroll>
                    <div class="nav-view-list">
                        <ol>
                            <li 
                            v-for="(item,index) in detailMenu" :key="index" 
                            :class="[bookPageIndex===index?'active':'']" 
                            @click="bookPageIndexActive(item,index)">
                                {{item.chaptername}}
                            </li>
                        </ol>
                    </div>
                </vue-scroll>
            </div>
            <div class="position-icon" @click="navLeftIsShow = !navLeftIsShow">
                <img src="@/assets/main_slither1_up.png" alt="" class="img" :class="[!navLeftIsShow?'active':'']">
                <img src="@/assets/newspapers_slither1_down.png" alt="" class="img-active" :class="[!navLeftIsShow?'active':'']">
            </div>
        </div>
        <div class="view-bottom-right" :class="[!navLeftIsShow?'active':'']"> 
            <VueDragResize
                :x="DragResize.x"
                :y="DragResize.y"
                :w="DragResize.w"
                :h="DragResize.h"
                :is-active="true"
                :is-resizable="false"
                style="outline: none!important;border: none!important;"
            >
                <div class="drag" 
                    v-if="bookName" 
                    :style="{
                        transform: `scale(${imgConfig.scale}) rotate(${imgConfig.rotate}deg)`
                    }">
                    <img :src="bookName.imagesEntities[pieceIndex].imageUrl" alt=""  >
                </div> 

            </VueDragResize>
            
        </div>
      </div>
  </div>
</template>

<script>   
import { btnList } from "./state" 
import VueDragResize from 'vue-drag-resize'
import { 
         chapterDetail,
         setDoRecord
 } from "@/api/lxc/index"
export default { 
  components:{  
      VueDragResize
  },
  data() {
    return {  
        detailMenu:[],
        pieceIndex:0,
        btnList:btnList,
        navLeftIsShow:true,
        bookPageIndex:0,
        imgConfig:{
            scale:1 ,//缩放
            rotate:0 , //旋转
        } , //浏览图片配置 
        DragResize: {
            x: 0,
            y: 0,
            w: 680,
            h: 450
        },
    };
  }, 
  computed:{ 
    bookName(){
        return this.detailMenu[this.bookPageIndex]
    }, 
  },
  watch:{ 
    bookName(){
        this.pieceIndex = 0
    }
  },
  created(){
      this.getDetail()
  },
  mounted(){

  },
  methods: { 
      goRouter(){
          console.log(123)
          this.$router.go(-1)
      },
      operationImg(item){
          const { name } = item 
          const { imagesEntities } = this.bookName
            // console.log(name,this.imgConfig)
          switch (name) {
              case '还原' :   
                  this.imgConfig = {
                        scale:1 ,//缩放
                        rotate:0 , //旋转
                    } 
                //   let vdr = document.getElementsByClassName("vdr")[0]
                //   vdr.style.left='0px'
                //   console.log(vdr.style)
                  break;
              case '放大' : 
                  if(this.imgConfig.scale > 6) return
                  this.imgConfig.scale = this.imgConfig.scale+0.2 
                  break; 
              case '缩小' : 
                  if(this.imgConfig.scale <= .4) return
                  this.imgConfig.scale = this.imgConfig.scale-0.2
                  break;
              case '左旋90度' : 
                  this.imgConfig.rotate = this.imgConfig.rotate-90 
                  break;
              case '右旋90度' :
                  this.imgConfig.rotate = this.imgConfig.rotate+90 
                  break;
              case '放大镜' :
                  break;
              case '首页' :
                  this.bookPageIndex = 0
                  this.setDoRecordFn( this.detailMenu[this.bookPageIndex].chapterid )

                  break;
              case '上一页' :
                  if(this.bookPageIndex === 0) {
                      this.$message({  message: '已经第一页啦' });
                      return
                  }
                  if(this.pieceIndex <= imagesEntities.length-1){
                      this.bookPageIndex--
                  }else{
                      this.pieceIndex--
                  }
                  this.setDoRecordFn( this.detailMenu[this.bookPageIndex].chapterid )


                  break;
              case '下一页' :
                  if(this.bookPageIndex === this.detailMenu.length-1) {
                      this.$message({  message: '已经最后一页啦' });
                      return
                  }
                  if(this.pieceIndex >= imagesEntities.length-1){
                      this.bookPageIndex++
                  }else{
                      this.pieceIndex++
                  }
                  this.setDoRecordFn( this.detailMenu[this.bookPageIndex].chapterid )

                  break;
              case '末页' :
                  this.bookPageIndex = this.detailMenu.length-1
                  this.setDoRecordFn( this.detailMenu[this.bookPageIndex].chapterid )

                  break;
            default:

          }
      }, 
      bookPageIndexActive(item,index){
          this.bookPageIndex = index
          this.setDoRecordFn( this.detailMenu[this.bookPageIndex].chapterid )
      },
      //获取 书详情
      async getDetail(){
          const chapterid = this.$route.query.chapterid
          const bookid = this.$route.query.bookid
          const { chapters} = await chapterDetail({
              chapterid:chapterid,
              bookid:bookid
          }) 
        //   this.detailBook = book
          this.detailMenu = chapters 
          this.bookPageIndex= this.detailMenu.findIndex((item)=>{ 
              return Number(item.chapterid) === Number(chapterid)
          }) 
          if(this.bookPageIndex === -1) this.bookPageIndex=0 

        this.setDoRecordFn( this.detailMenu[this.bookPageIndex].chapterid )

// return

        // this.detailMenu=this.detailMenu.map(item=>{
        //     item.imagesEntities=["http://upload.gongkong.com/Upload/gongkong/baiduEditorImage/202110/09/93da712afa4c4f1385ccde5e27bced34_w.jpg"]
        //     return item
        // })
        //   this.detailMenu[0].imagesEntities=["http://upload.gongkong.com/Upload/gongkong/baiduEditorImage/202110/09/aec29444ae0f445582f9e95e761efe9a_w.jpg"]
        //   this.detailMenu[1].imagesEntities=["http://upload.gongkong.com/Upload/gongkong/baiduEditorImage/202110/09/9cc629888b864999ac4142c31098cc00_w.jpg"]
        //   this.detailMenu[2].imagesEntities=["http://upload.gongkong.com/Upload/gongkong/baiduEditorImage/202110/09/ec4928371330472f88391a5e26eef227_w.png","http://upload.gongkong.com/Upload/gongkong/baiduEditorImage/202110/09/93da712afa4c4f1385ccde5e27bced34_w.jpg"]
        //   this.detailMenu[3].imagesEntities=["http://upload.gongkong.com/Upload/gongkong/baiduEditorImage/202110/09/1d5fcf6e66fc4cfeb3b95e0e7de4d7d4_w.jpg"]
        //   this.detailMenu[4].imagesEntities=["http://upload.gongkong.com/Upload/gongkong/baiduEditorImage/202110/09/c51df71190d14b0eab171a88b4f516da_w.jpg","http://upload.gongkong.com/Upload/gongkong/baiduEditorImage/202110/09/14c7d4f7189240f2a00ff2bf1f2baefc_w.png","http://upload.gongkong.com/Upload/gongkong/baiduEditorImage/202110/09/f054b29d601140b4b23a19d14ef8deca_w.jpg"]
        //   this.detailMenu[5].imagesEntities=["http://upload.gongkong.com/Upload/gongkong/baiduEditorImage/202110/09/9800fd285a3e4f43955845b5f3d1bd35_w.png"]

        //   this.detailMenu[this.detailMenu.length-1].imagesEntities=["http://upload.gongkong.com/Upload/gongkong/baiduEditorImage/202110/09/9800fd285a3e4f43955845b5f3d1bd35_w.png"]


      },
        async setDoRecordFn(id){
            const data = await setDoRecord({
                id
            })
            console.log(data)
        }
  },
  mounted(){
     
  }
};
</script>

<style>
    .el-tree>.el-tree-node .el-tree-node__content{
        /* background-color: #6a6158; */
        background: cornsilk;
    }
    .el-tree-node__content:hover {
    }

    .draggable{
        width: 100%!important;
        height: 100%!important;
        position: relative;
    }

    .vdr{
        height: 100%!important;
        width: 100%!important;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
<style scoped lang="less"> 
.detail-view{
    width: 140px
}


@import "./detail.less";
</style>
